import script from "./MediaNotesFeed.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaNotesFeed.vue?vue&type=script&setup=true&lang=js"

import "./MediaNotesFeed.vue?vue&type=style&index=0&id=5f337cb8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f337cb8"]])

export default __exports__